import {DesktopNotificationPrompt} from '../DesktopNotificationPrompt';
import {AppBar, Box, Container} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React from 'react';
import MainLogo from './MainLogo';
import NotificationsMenu from './NotificationsMenu/NotificationsMenu';
import ProfileMenu from './ProfileMenu';
import {useClientType} from '@/hooks/useClientType/useClientType';

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      display: 'none',
    },
  },
  container: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1464px',
    padding: '8px 40px 8px 64px',
    [theme.breakpoints.down('md')]: {
      padding: '16px',
    },
  },
  menuBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
}));

const TopBar: React.FC = () => {
  const styles = useStyles();
  const clientType = useClientType();

  return (
    <>
      <DesktopNotificationPrompt isPopover />
      <AppBar position="fixed" elevation={0} className={styles.appBar}>
        <Container
          maxWidth={false}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            borderBottom: '1px solid',
            borderBottomColor: 'grey.300',
          }}
        >
          <Box className={styles.container}>
            <MainLogo />
            <Box className={styles.menuBox}>
              {clientType === 'ENT' && <NotificationsMenu />}
              <ProfileMenu />
            </Box>
          </Box>
        </Container>
      </AppBar>
    </>
  );
};

export default TopBar;
